import { useMemo } from "react";
import { TicketManager, TicketManagerConfig } from "..";

/**
 * Used to fetch Tickets and all their necessary data, allowing filters, sorting and pagination
 * @returns a manager mobx class containing the tickets and the necessary functions to fetch them
 */
export const useTicketManager = (
  config?: TicketManagerConfig,
  fetchOnInit?: boolean
) => {
  // Create a new TicketManager instance
  const ticketManager = useMemo(() => {
    const manager = new TicketManager(config);
    if (fetchOnInit) manager.fetchTickets();

    return manager;
  }, []);

  return ticketManager;
};
